export default __webpack_public_path__ + "static/media/Elo.bd37487a.svg";